angular
  .module('app')
  .controller('MainindexController', MainindexController);

MainindexController.$inject = ['$state', '$translate'];

function MainindexController($state, $translate) {
  var vm = this;
  vm.isNavCollapsed = true;
  vm.langs = [
    'CA',
    'ES',
    'EN'
  ];

  vm.setLang = function (lng) {
    var id = lng.toLowerCase();
    $translate.use(id);
  };
}
